export const TTS_CONTROLS_CAPABILITY_ATTRIBUTE = "chickytutor.ttsControls";
export const TTS_CONTROL_RPC_SET = "tts.control.set";
export const TTS_CONTROLS_VERSION = 1;

export interface SpeakingRateRuntimeControl {
  kind: "range";
  min: number;
  max: number;
  step: number;
  value: number;
  applies: "next_synthesis";
}

export interface TtsRuntimeControlsCapability {
  version: 1;
  controls: {
    speaking_rate: SpeakingRateRuntimeControl;
  };
}

function isFiniteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

export function parseTtsRuntimeControls(
  attributes: Readonly<Record<string, string>> | undefined
): TtsRuntimeControlsCapability | null {
  const encoded = attributes?.[TTS_CONTROLS_CAPABILITY_ATTRIBUTE];
  if (!encoded) return null;

  try {
    const capability = JSON.parse(encoded) as Record<string, unknown>;
    if (capability.version !== TTS_CONTROLS_VERSION) return null;

    const controls = capability.controls as Record<string, unknown> | undefined;
    const speakingRate = controls?.speaking_rate as Record<string, unknown> | undefined;
    if (
      !speakingRate ||
      speakingRate.kind !== "range" ||
      speakingRate.applies !== "next_synthesis" ||
      !isFiniteNumber(speakingRate.min) ||
      !isFiniteNumber(speakingRate.max) ||
      !isFiniteNumber(speakingRate.step) ||
      !isFiniteNumber(speakingRate.value) ||
      speakingRate.min >= speakingRate.max ||
      speakingRate.step <= 0 ||
      speakingRate.value < speakingRate.min ||
      speakingRate.value > speakingRate.max
    ) {
      return null;
    }

    return {
      version: TTS_CONTROLS_VERSION,
      controls: {
        speaking_rate: {
          kind: "range",
          min: speakingRate.min,
          max: speakingRate.max,
          step: speakingRate.step,
          value: speakingRate.value,
          applies: "next_synthesis",
        },
      },
    };
  } catch {
    return null;
  }
}
